(function () {
  var root = document.querySelector('.bm-landing');
  if (!root) return;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---- expandable rows in #hero ---- */
  root.querySelectorAll('[data-bm-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var panel = root.querySelector('#' + btn.getAttribute('aria-controls'));
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      var plus = btn.querySelector('[data-bm-plus]');
      if (plus) plus.classList.toggle('rotate-45', !open);
      if (!panel) return;
      panel.classList.toggle('grid-rows-[1fr]', !open);
      panel.classList.toggle('opacity-100', !open);
      panel.classList.toggle('grid-rows-[0fr]', open);
      panel.classList.toggle('opacity-0', open);
    });
  });

  /* ---- six-thumbnail galleries (independent per offer) ---- */
  root.querySelectorAll('[data-bm-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-bm-main-image]');
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-bm-thumb]'));
    var index = 0;
    function select(next) {
      index = Math.min(Math.max(next, 0), thumbs.length - 1);
      thumbs.forEach(function (thumb, i) {
        var active = i === index;
        thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
        thumb.classList.toggle('border-plum', active);
        thumb.classList.toggle('border-transparent', !active);
      });
      var img = thumbs[index] && thumbs[index].querySelector('img');
      if (img && main) {
        main.setAttribute('src', img.getAttribute('src'));
        main.setAttribute('alt', img.getAttribute('alt') || '');
      }
    }
    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { select(i); });
    });
    var prev = gallery.querySelector('[data-bm-prev]');
    var next = gallery.querySelector('[data-bm-next]');
    if (prev) prev.addEventListener('click', function () { select(index - 1); });
    if (next) next.addEventListener('click', function () { select(index + 1); });
    select(0);
  });

  /* ---- "Read more reviews" ---- */
  root.querySelectorAll('[data-bm-reviews-more]').forEach(function (link) {
    link.addEventListener('click', function (event) {
      event.preventDefault();
      root.querySelectorAll('[data-bm-review-extra]').forEach(function (item) {
        item.classList.remove('hidden');
        item.classList.add('block');
      });
      if (link.parentElement) link.parentElement.classList.add('hidden');
    });
  });

  /* ---- mobile sticky bar ---- */
  var sticky = root.querySelector('[data-bm-sticky]');
  var hero = root.querySelector('#hero');
  if (sticky && hero && 'IntersectionObserver' in window) {
    var state = { heroPassed: false, blocked: {} };
    var blockers = ['#offer-1', '#offer-2', 'footer'].map(function (sel) { return root.querySelector(sel); })
      .filter(function (el) { return el; });
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.target === hero) {
          state.heroPassed = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
          return;
        }
        var key = entry.target.id || 'footer';
        if (entry.isIntersecting) state.blocked[key] = true; else delete state.blocked[key];
      });
      var show = state.heroPassed && Object.keys(state.blocked).length === 0;
      sticky.classList.toggle('translate-y-0', show);
      sticky.classList.toggle('translate-y-full', !show);
    });
    [hero].concat(blockers).forEach(function (el) { observer.observe(el); });
  }

  /* ---- smooth anchor scrolling ---- */
  root.querySelectorAll('a[href^="#"]').forEach(function (link) {
    if (link.hasAttribute('data-bm-reviews-more')) return;
    link.addEventListener('click', function (event) {
      var target = root.querySelector(link.getAttribute('href'));
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: reduced.matches ? 'auto' : 'smooth', block: 'start' });
    });
  });
})();